export default {
  setCity(state, value) {
    state.city = value
  },
  setCities(state, value) {
    state.cities = value
  },
  setCityFilters(state, filters) {
    state.cityFilters = filters
  },
  setCityByFilteredDistrict(state, value) {
    state.cityByFilteredDistrict = value
  },
}
